import { Box, Heading, Paragraph } from 'grommet'
import styled from 'styled-components'

export const DEFAULT_HEXAGON_WIDTH = 37
export const DEFAULT_HEXAGON_HEIGHT = 43

export const Wrapper = styled(Box)`
  flex-direction: row;
  margin: 0 auto;
`

export const Content = styled(Box)`
  max-width: ${({ maxWidth }) => maxWidth || '300'}px;
  width: 100%;

  ${({ theme }) => theme.below.tabletS`
    max-width: ${({ $maxWidthMobile }) => $maxWidthMobile || '250'}px;
  `}
`

export const TitleWrapper = styled(Box)`
  align-items: center;
  flex-direction: row;

  img {
    object-fit: contain;
  }

  ${({ theme, $sizeHexagonMobile }) => theme.below.mobileXL`
    img {
      width: ${
        $sizeHexagonMobile ? $sizeHexagonMobile.width : DEFAULT_HEXAGON_WIDTH
      }px;
      height: ${
        $sizeHexagonMobile ? $sizeHexagonMobile.height : DEFAULT_HEXAGON_HEIGHT
      }px;
    }
  `}
`

export const Title = styled(Heading)`
  color: ${({ theme, color }) =>
    theme.colors[color] || color || theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[7]};
  line-height: ${({ theme }) => theme.lineHeight[1]}px;
  margin-left: ${({ theme }) => theme.spaces[2]}px;
  text-transform: uppercase;

  ${({ theme, $mobileFontTitle }) => theme.below.mobileL`
    font-size: ${
      $mobileFontTitle ? $mobileFontTitle.fontSize : theme.fontSizes[3]
    }px;
    line-height: ${
      $mobileFontTitle ? $mobileFontTitle.lineHeight : theme.lineHeight[0]
    }px;
    font-weight: ${
      $mobileFontTitle ? $mobileFontTitle.weight : theme.fontWeight[7]
    };
    text-transform: ${
      $mobileFontTitle ? $mobileFontTitle.transform : 'uppercase'
    };
  `}
`

export const Subtitle = styled(Paragraph)`
  color: ${({ theme, color }) =>
    theme.colors[color] || color || theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
  line-height: ${({ theme }) => theme.lineHeight[0]}px;
  margin-top: ${({ theme }) => theme.spaces[3]}px;
  white-space: pre-wrap;

  ${({ theme }) => theme.below.mobileL`
    font-size: ${({ theme, $mobileFont }) =>
      $mobileFont ? $mobileFont.fontSize : theme.fontSizes[2]}px;
    font-weight: ${({ theme, $mobileFont }) =>
      $mobileFont ? $mobileFont.weight : theme.fontWeight[2]};
    line-height: ${({ theme, $mobileFont }) =>
      $mobileFont ? $mobileFont.lineHeight : theme.lineHeight[0]}px;
  `}
`
